import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleError } from "../../../shared/functions/handleError";
import { enqueueSnackbar } from "notistack";
import { IEmailTemplate } from "../../../shared/interfaces/email-template/IEmailTemplate";
import { AdminEmailTemplateService } from "../service";
import EmailTemplateForm from "./EmailTemplateForm";
import { emailTemplateForm } from "./EmailTemplateCreate";

const EmailTemplateUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control } = useForm<IEmailTemplate>({
    resolver: yupResolver(
      emailTemplateForm,
    ) as unknown as Resolver<IEmailTemplate>,
    defaultValues: async () =>
      (await AdminEmailTemplateService.getSingle(Number(id))
        .then((response) => {
          return {
            ...response,
          };
        })
        .catch(handleError)) as unknown as IEmailTemplate,
  });
  const submitHandler = (formData: IEmailTemplate) => {
    AdminEmailTemplateService.update(formData, Number(id))
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyUpdated", { title: formData?.name }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <EmailTemplateForm isUpdate control={control} />
    </form>
  );
};
export default EmailTemplateUpdate;
